import { getExpressionById, getAllExpressionBybot, getAllExpression, getAllExpressionByIntents, AddListUtterance, addExpression, removeUtterance, updateUtterance } from '../api/expression.service.js'

export default {
  state:{
    expression:{},
    expressions:[],
    synonyms: []
  },
  getters:{
    getExpression(state){
      return state.expression
    },
    getAllExpression(state){
      return state.expressions
    }

  },
  mutations:{
    setExpression(state, express){
      state.expression = express
    },
    setExpressionByintent(state, expressions){
      state.expressions = expressions
    },
    setAllExpressionByBot(state, expressions){
      state.expressions = expressions
    },
    setAllExpression(state, expres){
      state.expressions = expres
    },
    addExpression(state, expr){
      state.expression = expr
      state.expressions.splice(0,0,expr)
    },
    AddListUtterance(state, expr){
      state.expression = expr
      state.expressions.splice(0,0,expr)
    }
  },
  actions:{
    async setExpression(context, id){
      let express = await getExpressionById(id)
      context.commit('setExpression', express)
    },

    async setAllExpression(context){
      let expressions = await getAllExpression()
      console.log("teeeeeeeeest", expressions)
      console.log('test expressionsssssss', expressions.source)
      context.commit('setAllExpression', expressions)
    },
    async setAllExpressionByBot(context, id){
      let expression = await getAllExpressionBybot(id)

      context.commit('setAllExpressionByBot', expression)
    },
    async addExpression(context, express){
      let expr = await addExpression(express)
      console.log('test expression', expr )
      context.commit('setExpressionByintent', expr.expressions)
    },
    async setExpressionByintent(context, id){
      let exprs = await getAllExpressionByIntents(id)
      console.log("##################setExpressionByintent##############", exprs)
      context.commit('setAllExpression', exprs)
    },
  
    async deleteUtterance(context, id){
      console.log("heeey store delete",id)
      let upExpress = await removeUtterance(id)
      context.commit('setExpressionByintent', upExpress)
    },
    async updateUtterance(context, utt){
      let upUtterance = await updateUtterance(utt)
      context.commit('setExpression', upUtterance)
    },
    async AddListUtterance(context, utrList){
      let utrs = await AddListUtterance(utrList)
      console.log("test utrs store", utrs)
      context.commit('setExpressionByintent', utrs)
    }
  }
}





// WEBPACK FOOTER //
// ./src/store/expression.store.js